import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const staffImessageApprovalDecisionPayloadSchema = z
    .object({
        type: z.literal('staff_imessage_approval_decision').optional(),
        decision: z.string(),
        summary: z.string(),
        tool_name: z.string().nullable().optional(),
        command_id: z.uuid().nullable().optional(),
        decided_at: z.iso.datetime({ offset: true }).nullable().optional(),
        decided_at_timezone: z.string().nullable().optional(),
    })
    .strip();

export const staffImessageApprovalDecisionDefinitions = {
    staff_imessage_approval_decision: defineInvisible(
        'staff_imessage_approval_decision',
        {
            disposition: 'invisible',
            schema: staffImessageApprovalDecisionPayloadSchema,
            malformed: { kind: 'skip' },
            evidence: null,
        },
    ),
} as const;

export const staffImessageApprovalDecisionContractFixtures = {
    valid: {
        type: 'staff_imessage_approval_decision',
        decision: 'approved',
        summary: 'Internal approval summary',
        tool_name: 'internal_tool_name',
        command_id: '00000000-0000-4000-8000-000000000001',
        decided_at: '2026-08-28T12:00:00Z',
        decided_at_timezone: 'America/New_York',
    },
    malformed: {
        type: 'staff_imessage_approval_decision',
        decision: 'approved',
        summary: 7,
    },
} as const;
